import useApiManager from 'networking/ApiManager';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { add, editIconY, uploaded, eyeView } from 'res/images';
import { Modal, Button, ButtonToolbar, Placeholder } from 'rsuite';
import PrescriptionActivityCreate from 'whealth-core-web/forms/PrescriptionActivityCreate';
import CoreButton from './CoreButton';
import { profileImage, dateFormat, dayTime, timeFormat, teamRoles, scrollToTop, splitArrData } from './Helper';
import Loader from './Loader';
import './prescription.css';
import { Pagination, Select2DropDown, EmptyView } from 'whealth-core-web/components';
import CommonToolTip from './CommonToolTip';
import { useDispatch } from 'react-redux';
import { setAlerts, setMedicineActiveCard, setReduxPrescriptionData } from 'redux/Slices';
import parse from 'html-react-parser';
import { act } from 'react';
import { pdf } from '@react-pdf/renderer';
import OPDReportPDF from '../../whealth-core-web/components/PrescriptionPdf/Content'

function RenderPrescriptionTab(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const { userData,newPrescription, getPatientData } = props;
  const { id } = useParams();
  const ApiClient = useApiManager();
  const navigate = useNavigate();
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [alertType, setAlertType] = useState('alert-success');
  const [prescriptionData, setPrescriptionData] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentList, setDepartmentList] = useState([]);
  const [pdfModal, setPdfModule] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [printItem, setprintItem] = useState({});
  const [activeDept, setActiveDept] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const is_super_admin = userData?.role == 'super_admin';

  const dispatch = useDispatch();
  useEffect(() => {
    getListData();
  }, [id, currentPage]);
  const closeModalPdf = (item) => {
    setPdfModule(!pdfModal);
  };
  const closeShowModal = (item) => {
    setShowModal(!showModal);
  };

  const openModalPdf = async (item) => {
    setprintItem(item);
  
    if (!pdfModal) {
      setIsLoading(true);
      try {
        const res = await ApiClient.prescriptionPdfDownload(id, item.id);
        let blob, blobURL;
  
        if (res.data) {
          // Assuming pdf() returns a Promise
          blob = await pdf(<OPDReportPDF data={res.data} />).toBlob();
          blobURL = URL.createObjectURL(blob);
        } else {
          blob = new Blob([res.data], { type: 'application/pdf' });
          blobURL = URL.createObjectURL(blob);
        }
  
        setPdfUrl(blobURL);
        setPdfModule(!pdfModal);
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
  };
  // const openModalPdf = (item) => {
  //   setprintItem(item);
  //   if (!pdfModal) {
  //     setIsLoading(true);
  //     ApiClient.prescriptionPdfDownload(id, item.id)
  //       .then((res) => {
  //         setIsLoading(false);
  //         var blob = new Blob([res.data], { type: 'application/pdf' });

  //         var blobURL = URL.createObjectURL(blob);
  //         setPdfUrl(blobURL);
  //         setPdfModule(!pdfModal);
  //         setIsLoading(false);
  //       })
  //       .catch((err) => {
  //         setIsLoading(false);
  //         console.log(err);
  //       });
  //   }
  // };

  useEffect(() => {
    getDepartment();
  }, []);

  const getDepartment = () => {
    ApiClient.getDepartment()
      .then((res) => {
        setDepartmentList(res.data);
      })
      .catch((err) => {
        console.warn('getDepartment error', err);
      });
  };

  const getListData = (departmentID = selectedDepartment, page = currentPage, noPrescription = false) => {
    setIsLoading(true);
    let params = { page };
    if (noPrescription) {
      params.no_prescription = true;
    }
    if (departmentID) {
      params.department_id = departmentID;
    }
    ApiClient.prescriptionList(id, params)
      .then((res) => {
        setIsLoading(false);
        dispatch(setMedicineActiveCard(res.data.filter((item) => item.status === 'published')));
        setTotalPages(res.headers['total-pages']);
        setPrescriptionData(res.data);
        dispatch(setReduxPrescriptionData(res.data.filter((item) => item.status === 'published')));
        scrollToTop();
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const statusPublish = (item) => {
    setIsLoading(true);
    ApiClient.statusPublish(id, item.id)
      .then((res) => {
        setIsLoading(false);
        getListData();
        getPatientData();
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const sampleData = {
    name: 'Ramnik Shantilal Agarwal',
    age: 56,
    gender: 'M',
    uhid: 'RHPL/KH/79081',
    opdDate: '12/03/25',
    opdTime: '09:45 AM',
    opdType: 'First',
    mode: 'In-Person',
    height: '5 ft 7 in',
    weight: '85 Kg',
    bmi: 6,
    pulse: 120,
    bp: '96/140',
    respiration: 'Lorem Ipsum',
    temperature: '80°C',
    painScore: 8,
    final_diagnosis: 'Lorem ipsum dolor sit amet',
    red_flags_if_any: 'None observed.',
    principal_complaints: 'Patient reports mild chest pain.',
    treatment_history: 'No prior surgeries.',
    health_conditions_past_current: 'Hypertension, Diabetes',
    current_medications: 'Metformin, Amlodipine',
    drug_allergies_if_any: 'None',
    investigation_and_reports: 'Blood test pending',
  };
  const statusUnpublished = (item) => {
    setIsLoading(true);
    ApiClient.statusUnpublished(id, item.id)
      .then((res) => {
        setIsLoading(false);
        getPatientData();
        getListData();
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const showDosageTimes = (arr) => {
    return arr.map((item, index) => {
      const objectKeys = Object.keys(item);
      return (
        <div key={index} className={`badge badge-pill me-3 ${item[objectKeys[1]]}`}>
          <img src={item[objectKeys[0]]} className='icon' /> {objectKeys[0]}
        </div>
      );
    });
  };
  const handleOpenPDF = async () => {
    const blob = await pdf(<OPDReportPDF data={sampleData} />).toBlob();
    const url = URL.createObjectURL(blob);
    // window.open(url, '_blank');
    setPdfUrl(url)
    setShowModal(true);
  };
  const handleModalClose = () => {
    getListData();
    setOpen(false);
  };
  const printPDF=async()=>{
    const blob = await pdf(<OPDReportPDF data={sampleData} />).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  }
  const customGoalActivityModal = () => {
    return (
      <div>
        <Modal backdrop='static' size='md' open={open} onClose={() => handleModalClose()}>
          <Modal.Header />
          <PrescriptionActivityCreate handleSubmit={handleModalClose} setLoading={setIsLoading} data={open} />
        </Modal>
      </div>
    );
  };
  const PDFModal = ({ url, onClose }) => {
    if (!url) return null;

    return (
      <div className='modal-backdrop'>
        <div className='modal-content'>
          <button onClick={onClose} className='close-btn'>×</button>
          <iframe src={url} width='100%' height='600px' title='PDF Preview'></iframe>
        </div>
      </div>
    );
  };

  const renderListDataMedicine = useCallback(
    (medicinesData) => {
      return (
        medicinesData.prescription_medicines &&
        medicinesData.prescription_medicines.map((item, index) => {
          return (
            <div key={index} className='p-2 mt-3 mileStone rounded'>
              <div className='d-flex justify-content-between '>
                <div
                  onClick={() => {
                    navigate(`/patient/${id}/prescription/${medicinesData.id}/medicines/${item.id}/show`);
                  }}
                  className='cardHeading pointer'
                >
                  <span className='semiBold capitalize'>{item?.medicine?.medicine_title_repr}</span>
                  <div className='capitalize'>{item?.medicine?.medicine_category}</div>
                </div>
                <div className='d-flex'>
                  <div className='date me-2 '>
                    {item.activity && item.activity.last_updated
                      ? dateFormat(item.activity.last_updated) + ' · ' + timeFormat(item.activity.last_updated)
                      : 'No Activity'}
                  </div>
                  {/* <div className="d-flex justify-content-end addActivityBtn">
                    {medicinesData.status == "published" && (
                      <CommonToolTip
                        placement={"top"}
                        item={<img src={add} onClick={() => setOpen(item)} className="" />}
                        showValue={"Add Activity"}
                      />
                    )}
                  </div> */}
                </div>
              </div>
              {!item.is_optional ? (
                <div className='tagsHolder mt-2'>{showDosageTimes(dayTime(item.dosage))}</div>
              ) : (
                <div className='badge badge-light me-3 text-black mt-2'>As Needed</div>
              )}
              {!item.is_optional && (
                <div className='progressBar  mt-2 d-flex align-items-center'>
                  <div className='progress  w-100 flex-fill '>
                    <div
                      className='progress-bar '
                      role='progressbar'
                      aria-valuenow='0'
                      style={{
                        width: parseInt((item?.activity?.activity_number / item?.duration) * 100) + '%',
                      }}
                      aria-valuemin='0'
                      aria-valuemax={item?.activity?.activity_number}
                    ></div>
                  </div>
                  <div className='progress-value '>
                    {item?.activity && item?.activity?.activity_number ? item?.activity?.activity_number : '0'}/{item?.duration} Days
                  </div>
                </div>
              )}
            </div>
          );
        })
      );
    },
    [prescriptionData]
  );

  const handlePublishAndPrint = () => {
    const windowConfirm = window.confirm(`Are you sure, you want to publish prescription?`);
    if (windowConfirm) {
      ApiClient.statusPublish(id, printItem.id)
        .then((res) => {
          setIsLoading(false);
          let iframe = document.createElement('iframe'); //load content in an iframe to print later
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = pdfUrl;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
          getListData();
          getPatientData();
        })
        .catch((err) => {
          setIsLoading(false);
        });
      setPdfModule(false);
    }
  };


  const getPdf = async (item) => {
    setIsLoading(true);
    try {
      const res = await ApiClient.prescriptionPdfDownload(id, item.id);
      let blob, blobURL;

      if (res.data) {
        // Assuming pdf() returns a Promise
        blob = await pdf(<OPDReportPDF data={res.data} />).toBlob();
        blobURL = URL.createObjectURL(blob);
      } else {
        blob = new Blob([res.data], { type: 'application/pdf' });
        blobURL = URL.createObjectURL(blob);
      }
      setIsLoading(false);
      let iframe = document.createElement('iframe'); //load content in an iframe to print later
      document.body.appendChild(iframe);
      iframe.style.display = 'none';
      iframe.src = blobURL;
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow.print();
        }, 1);
      };
    } catch (err) {
      setIsLoading(false);
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // const getPdf = (item) => {
  //   setIsLoading(true);
  //   ApiClient.prescriptionPdfDownload(id, item.id)
  //     .then((res) => {
  //       setIsLoading(false);
  //       var blob = new Blob([res.data], { type: 'application/pdf' }); //this make the magic
  //       var blobURL = URL.createObjectURL(blob);
  //       let iframe = document.createElement('iframe'); //load content in an iframe to print later
  //       document.body.appendChild(iframe);
  //       iframe.style.display = 'none';
  //       iframe.src = blobURL;
  //       iframe.onload = function () {
  //         setTimeout(function () {
  //           iframe.focus();
  //           iframe.contentWindow.print();
  //         }, 1);
  //       };
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       console.log(err);
  //     });
  // };

  const prescriptionDelete = (questionId) => {
    setIsLoading(true);
    // seterror({});
    ApiClient.deletePrescription(id, questionId)
      .then((res) => {
        setIsLoading(false);
        getListData();
        console.log(res);
        dispatch(setAlerts({ patient: { title: 'Prescription deleted successfully.', type: 'alert-success' } }));
      })
      .catch((err) => {
        // setIsLoading(false);
        if (err.response.status == 500) {
          setIsShowAlert('Internal server error');
        } else {
          setIsShowAlert(err.response.data.message);
        }
        setAlertType('alert-danger');
        setIsShowAlert(err.response.data.detail || err.response.data.message);
        console.log(err);
      });
  };

  const renderMultiSelect = (data) => {
    let ansArr = splitArrData(data.answer, '|');
    return (
      <ul>
        {ansArr.map((item, index) => {
          return <li key={index}>{item}</li>;
        })}
      </ul>
    );
  };

  const prescriptionDataObj = (data) => {
    if (data?.length) {
      let sortedData = [...data].sort(function (a, b) {
        return a.order - b.order;
      });
      return sortedData.map((item, i) => {
        return (
          <div className='d-flex'>
            <div className='w-100'>
              <span className='semiBold capitalize'>{item.label} · </span>
              <span className='prescriptiontime'>
                <pre className='zeefitness prefont_family firstletter_capitalize'>
                  {item.type == 'multi_select'
                    ? renderMultiSelect(item)
                    : item.type == 'date' && dateFormat(item.answer) != 'Invalid Date'
                      ? dateFormat(item.answer)
                      : item.answer}
                </pre>
              </span>
            </div>
          </div>
        );
      });
    }
  };

  const renderDepartmentDropdown = () => {
    return (
      <Select2DropDown
        placement='auto'
        value={selectedDepartment}
        data={departmentList}
        labelKey='name'
        // label={'Department'}
        placeholder={'Department'}
        valueKey='id'
        getObjData
        retuired
        onSelect={(_, selectedValue) => {
          setSelectedDepartment(selectedValue?.id || '');
          setCurrentPage(1);
          getListData(selectedValue?.id || '', 1);
        }}
        showMSG={''}
      />
    );
  };

  const renderPrescriptionList = () => {
    return (
      <>
        <div class='default-tab'>
          <ul class='nav nav-tabs mb-3' role='tablist'>
            <li class='nav-item'>
              <a
                class={activeDept == 0 ? 'nav-link active' : 'nav-link'}
                style={activeDept == 0 ? { cursor: 'pointer', color: '#133696' } : { cursor: 'pointer', color: '#575757' }}
                data-toggle='tab'
                onClick={(e) => {
                  e.preventDefault();
                  setActiveDept(0);
                  getListData();
                }}
              >
                All
              </a>
            </li>
            <li class='nav-item'>
              <a
                class={activeDept == -1 ? 'nav-link active' : 'nav-link'}
                style={activeDept == -1 ? { cursor: 'pointer', color: '#133696' } : { cursor: 'pointer', color: '#575757' }}
                data-toggle='tab'
                onClick={(e) => {
                  e.preventDefault();
                  setActiveDept(-1);
                  getListData(0, 1, true);
                }}
              >
                No Prescription
              </a>
            </li>
            {departmentList.map((dept, deptIndex) => {
              return (
                <li class='nav-item'>
                  <a
                    class={activeDept == dept?.id ? 'nav-link active' : 'nav-link'}
                    style={activeDept == dept?.id ? { cursor: 'pointer', color: '#133696' } : { cursor: 'pointer', color: '#575757' }}
                    onClick={(e) => {
                      e.preventDefault();
                      setActiveDept(dept?.id);
                      getListData(dept?.id);
                    }}
                  >
                    {dept?.name}
                  </a>
                </li>
              );
            })}
          </ul>
          <div class='tab-content'>
            <div class='tab-pane fade show active' id='home' role='tabpanel'>
              <div class='p-t-15'>
                {/* content */}

                {prescriptionData && prescriptionData.length > 0 ? (
                  prescriptionData.map((item, index) => {
                    const newText = item;

                    const buttonsData = () => {
                      return (
                        <div className='headingMilestone d-flex justify-content-between'>
                          <div className='d-flex'>
                            <div>
                              <b>Assigned On &nbsp; &nbsp;</b>
                              {dateFormat(item.created_at)} · {timeFormat(item.created_at)}
                            </div>
                            <div className='d-block  ms-2 '>
                              <span className={`badge bg-info  capitalize ${item.status}`}>{item.status}</span>
                            </div>
                          </div>
                          <div
                            className='memberShipDetails'
                            style={{ display: `${activeDept == -1 ? 'none' : 'flex'}`, flexDirection: 'row', alignItems: 'center' }}
                          >
                            <>
                              {item.status != 'published' && !userData?.read_only && (
                                <div
                                  className='mb-1 ms-2 pointer'
                                  onClick={() => {
                                    let windoConfirm = window.confirm('Are you sure you want to delete this prescription?');
                                    if (windoConfirm) {
                                      prescriptionDelete(item.id);
                                    }
                                  }}
                                >
                                  <div className='pt-1'>
                                    <CommonToolTip placement={'top'} item={<span class='material-icons-outlined'>delete_outline</span>} showValue={'Delete'} />
                                  </div>
                                </div>
                              )}
                              <div className='mb-1 ms-2 pointer' onClick={() => navigate(`/patient/${id}/prescriptions/new`, { state: { id: item.id } })}>
                                <CommonToolTip
                                  placement={'top'}
                                  item={
                                    <div className='pt-1'>
                                      <span className='material-icons-outlined' style={{ color: '#757575' }}>
                                        content_copy
                                      </span>
                                    </div>
                                  }
                                  showValue={'Duplicate'}
                                />
                              </div>
                              {item?.audio_file && is_super_admin ? 
                                <a
                                href={item?.audio_file}     
                                download                      
                                className="mb-1 ms-2 pointer"
                              >
                                <CommonToolTip
                                  placement="top"
                                  item={<span className="material-icons-outlined">audio_file</span>}
                                  showValue="Prescription Audio"
                                />
                              </a>
                              : null}
                              

                              {item.status == 'published' && (
                                <div className='mb-1 ms-2 pointer' onClick={() => getPdf(item)}>
                                  <CommonToolTip placement={'top'} item={<span class='material-icons-outlined'>visibility</span>} showValue={'Download PDF'} />
                                </div>
                              )}
                              {item.status == 'draft' && !userData?.read_only && (
                                <div
                                  onClick={() => {
                                    navigate(`/patient/${id}/prescriptions/${item.id}/edit`, { state: { id: item.id } });
                                  }}
                                  className='mb-2 ms-2 pointer'
                                >
                                  <CommonToolTip
                                    placement={'top'}
                                    item={<img src={editIconY} className='icon' style={{ cursor: 'pointer' }} />}
                                    showValue={'Edit'}
                                  />
                                </div>
                              )}
                              {item.status !== 'published' ? (
                                <div
                                  onClick={() => {
                                    openModalPdf(item);
                                  }}
                                  className='ms-2 pointer'
                                >
                                  <CommonToolTip placement={'top'} item={<span class='material-icons-outlined'>visibility</span>} showValue={'View'} />
                                </div>
                              ) : (
                                <CommonToolTip
                                  placement={'top'}
                                  item={
                                    <div className='mb-2 ms-2 pointer'>
                                      <div className='form-check form-switch toggleBtn pt-1'>
                                        <input
                                          className='form-check-input'
                                          style={{ cursor: 'pointer' }}
                                          checked={item.status == 'published'}
                                          onChange={(e) => {
                                            const windowConfirm = window.confirm(
                                              `Are you sure,you want to ${item.status == 'published' ? 'unpublish' : 'publish'} prescription?`
                                            );
                                            if (windowConfirm && item.status !== 'published') {
                                              statusPublish(item);
                                            } else if (windowConfirm) {
                                              statusUnpublished(item);
                                            }
                                          }}
                                          type='checkbox'
                                          role='switch'
                                        />
                                      </div>
                                    </div>
                                  }
                                  showValue={` ${item.status == 'published' ? 'Unpublish' : 'Publish'} `}
                                />
                              )}
                            </>
                          </div>
                        </div>
                      );
                    };

                    if (item?.is_new && item?.is_new == 1) {
                      return (
                        <div className='cardDataBorder'>
                          <div key={index} className='d-flex'>
                            <div className='w-100'>
                              <div className='cardMilestone'>
                                {/* New */}
                                {!userData?.read_only && !['ee', 'ee_manager'].includes(userData?.role) && (
                                  <>
                                    {buttonsData()}
                                  </>
                                )}
                                
                                <div className='d-flex mt-1 mb-3 justify-content-between align-items-center'>
                                  <div className='d-flex'>
                                    <div className='me-2'>
                                      <img className='rounded coachImage float-start img-fluid' src={profileImage(item.admin.gender, item.admin.profile_url)} />
                                    </div>
                                    <div className='w-75 '>
                                      <h5 className='coachtext capitalize'>{item.admin.full_name}</h5>
                                      <p className='zeefitness capitalize'>{teamRoles(item.admin.role)}</p>
                                    </div>
                                  </div>
                                  <div>
                                    {item?.department?.name ? <div class='badge capitalize lightGrayBadge'>Department {item?.department?.name}</div> : null}
                                  </div>
                                </div>
                                <div>
                                  {item.doctor ? (
                                    <div className='w-100 mb-2'>
                                      <span className='semiBold capitalize'>
                                        Doctor ·
                                        <div>
                                          <span className='prescriptiontime'>{item.doctor.full_name} </span>
                                        </div>
                                      </span>
                                    </div>
                                  ) : null}
                                </div>
                                {activeDept != -1 && (
                                  <>
                                    {item?.vital_data ? (
                                      <div class='d-flex'>
                                        <div class='w-100'>
                                          <span class='semiBold capitalize'>Vital Details - </span>
                                          <span class='prescriptiontime'>
                                            <pre class='zeefitness prefont_family firstletter_capitalize'>
                                              <ul>
                                                <li>BP : {item?.vital_data?.bp}</li>
                                                <li>BMI : {item?.vital_data?.bmi}</li>
                                                <li>Pulse : {item?.vital_data?.pulse}</li>
                                                <li>Height : {item?.vital_data?.height}</li>
                                                <li>Weight : {item?.vital_data?.weight}</li>
                                                <li>Respiration : {item?.vital_data?.respiration}</li>
                                                <li>Temperature : {item?.vital_data?.temperature}</li>
                                              </ul>
                                            </pre>
                                          </span>
                                        </div>
                                      </div>
                                    ) : null}
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Presenting Complaints - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {parse(item?.pms_data?.principal_complaints || '')}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Pain Treatment History - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {parse(item?.pms_data?.pain_treatment_history || '')}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Health Condition - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {Array.isArray(item?.pms_data?.health_condition) ? (
                                              <ul>
                                                {item?.pms_data?.health_condition.map((value, index) => (
                                                  <li>
                                                    {value?.healthCondition} : {value?.remark}
                                                  </li>
                                                ))}
                                              </ul>
                                            ) : null}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    {/* Red Alerts*/}
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Red Alerts - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {Array.isArray(item?.red_alert) ? (
                                              <ul>
                                                {item?.red_alert.map((value, index) => (
                                                  <li>
                                                    {value?.redAlert} : {value?.remark}
                                                  </li>
                                                ))}
                                              </ul>
                                            ) : null}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Current Medications - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {Array.isArray(item?.medication_data) ? (
                                              <ul>
                                                {item?.medication_data.map((value, index) => (
                                                  <li>
                                                    {value?.current_medication} : {value?.remark}
                                                  </li>
                                                ))}
                                              </ul>
                                            ) : null}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Drug Allergies - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {Array.isArray(item?.pms_data?.drug_allergies) ? (
                                              <ul>
                                                {item?.pms_data?.drug_allergies.map((value, index) => (
                                                  <li>
                                                    {value?.data} : {value?.remark}
                                                  </li>
                                                ))}
                                              </ul>
                                            ) : null}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Previous Investigation Report- </span>
                                        <span class='precloseShowModalscriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {parse(item?.pms_data?.previous_investigation_report || '')}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                    {/* Investigation / Advice */}
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Investigation / Advice - </span>
                                      </div>
                                    </div>
                                    {item?.investigation_data ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '45%' }}>Test</th>
                                            <th style={{ width: '45%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.investigation_data.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.test || value?.investigationtests}</td>
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    {item?.imaging_data ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '45%' }}>Imaging</th>
                                            <th style={{ width: '45%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.imaging_data.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.image || value?.investigationimaging}</td>
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    {/* pms_data */}
                                    {item?.pms_data ? (
                                      <div class='d-flex'>
                                        <div class='w-100'>
                                          <span class='semiBold capitalize'>PMS Details - </span>
                                          <span class='prescriptiontime'>
                                            <pre class='zeefitness prefont_family firstletter_capitalize'>
                                              <ul>
                                                <li>Pain Score : {item?.pms_data?.vas_score}</li>
                                                <li>Next Checkin : {item?.pms_data?.next_checkin_date}</li>
                                              </ul>
                                            </pre>
                                          </span>
                                        </div>
                                      </div>
                                    ) : null}
                                    {/* diagnosis_data */}
                                    {item?.diagnosis_data ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '20%' }}>Pain Site</th>
                                            <th style={{ width: '40%' }}>{item?.pms_data?.is_final ? <>Final Diagnosis</> : <>Provisional Diagnosis</>}</th>
                                            <th style={{ width: '40%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.diagnosis_data.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.pain_site}</td>
                                              <td>{value?.diagnosis || value?.provisionaldiagnosis}</td>
                                              {/* <td>{value?.diagnosis}</td> */}
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    {/* def_diagnosis_data */}
                                    {item?.def_diagnosis_data ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '20%' }}>Pain Site</th>
                                            <th style={{ width: '40%' }}>Differential Diagnosis</th>
                                            <th style={{ width: '40%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.def_diagnosis_data.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.pain_site}</td>
                                              <td>{value?.diagnosis || value?.differentialdiagnosis}</td>
                                              {/* <td>{value?.diagnosis}</td> */}
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    {/* treatment_procedure_data */}
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Treatment - </span>
                                      </div>
                                    </div>
                                    {item?.treatment_procedure_data ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '20%' }}>Pain Site</th>
                                            <th style={{ width: '40%' }}>Treatment Procedure</th>
                                            <th style={{ width: '40%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.treatment_procedure_data.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.pain_site}</td>
                                              <td>{value?.treatment || value?.treatmentprocedure}</td>
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    {item?.imaging_data ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '45%' }}>Other Treatment</th>
                                            <th style={{ width: '45%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.treatment_other_data.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.treatment || value?.treatmentother}</td>
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    {/* Treatment Medication */}
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>Treatment Medication - </span>
                                      </div>
                                    </div>
                                    {/* [{"meal": "meal", "brand": "3", "remark": "rem", "regimen": "0-1-1", "medication": "1", "other_regimen": ""}] */}
                                    {item?.treatment_medication ? (
                                      <table className='table table-bordered table-hover'>
                                        <thead>
                                          <tr style={{ 'background-color': '#e9efff' }}>
                                            <th style={{ width: '10%' }}>SNo</th>
                                            <th style={{ width: '18%' }}>Medication</th>
                                            <th style={{ width: '18%' }}>Regimen</th>
                                            <th style={{ width: '18%' }}>Meal</th>
                                            {/* <th style={{ width: '18%' }}>Brand</th> */}
                                            <th style={{ width: '18%' }}>Duration</th>
                                            <th style={{ width: '18%' }}>Remark</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {item?.treatment_medication.map((value, index) => (
                                            <tr>
                                              <td>{index + 1}</td>
                                              <td>{value?.medication}</td>
                                              {/* <td>{value?.brand}</td> */}
                                              {value?.regimen == 'Other' ? <td>{value?.other_regimen}</td> : <td>{value?.regimen}</td>}
                                              <td>{value?.meal}</td>
                                              
                                              <td>{value?.duration}</td>
                                              <td>{value.remark}</td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    ) : null}
                                    <div class='d-flex'>
                                      <div class='w-100'>
                                        <span class='semiBold capitalize'>MDT consults advised - </span>
                                        <span class='prescriptiontime'>
                                          <pre class='zeefitness prefont_family firstletter_capitalize'>
                                            {item?.pms_data?.mdt_consults_advised === 'External Consult' ? (
                                              <>
                                                <ul>
                                                  <li>External Consult</li>
                                                </ul>
                                                <p class='semiBold capitalize'>
                                                  External Consult Referred :{' '}
                                                  <span class='zeefitness prefont_family firstletter_capitalize'>
                                                    {item?.pms_data?.external_consultation_referred ? item?.pms_data?.external_consultation_referred : 'N/A'}
                                                  </span>
                                                </p>
                                              </>
                                            ) : (
                                              <>
                                                {Array.isArray(item?.pms_data?.mdt_consults_advised) ? (
                                                  <ul>
                                                    {item?.pms_data?.mdt_consults_advised.map((value, index) => (
                                                      <li>{value}</li>
                                                    ))}
                                                  </ul>
                                                ) : (
                                                  'No'
                                                )}
                                              </>
                                            )}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className='cardDataBorder'>
                          <div key={index} className='d-flex'>
                            <div className='w-100'>
                              <div className='cardMilestone'>
                                {buttonsData()}
                                <div className='d-flex mt-1 mb-3 justify-content-between align-items-center'>
                                  <div className='d-flex'>
                                    <div className='me-2'>
                                      <img className='rounded coachImage float-start img-fluid' src={profileImage(item.admin.gender, item.admin.profile_url)} />
                                    </div>
                                    <div className='w-75 '>
                                      <h5 className='coachtext capitalize'>{item.admin.full_name}</h5>
                                      <p className='zeefitness capitalize'>{teamRoles(item.admin.role)}</p>
                                    </div>
                                  </div>
                                  <div>
                                    {item?.department?.name ? <div class='badge capitalize lightGrayBadge'>Department {item?.department?.name}</div> : null}
                                  </div>
                                </div>
                                <div>
                                  {item.doctor ? (
                                    <div className='w-100 mb-2'>
                                      <span className='semiBold capitalize'>
                                        Doctor ·
                                        <div>
                                          <span className='prescriptiontime'>{item.doctor.full_name} </span>
                                        </div>
                                      </span>
                                    </div>
                                  ) : null}
                                </div>
                                {item?.data && prescriptionDataObj(item?.data)}
                                {item?.enable_medicine && item?.prescription_medicines?.length ? (
                                  <div className='d-flex'>
                                    <div className='newMilestone warning w-100'>
                                      <div className='badge badge-light me-3 text-black'>Medical Prescription</div>
                                      {renderListDataMedicine(item)}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <EmptyView />
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className='d-flex justify-content-between'>
        <div className='pt-3 mb-3'>
        {!userData?.read_only && !['ee', 'ee_manager'].includes(userData?.role) && (
          <button type='button' className='btn mt-3 btn-outline-primary' onClick={newPrescription}>
            <img src={add} className='icon' /> New Prescription
          </button>
        )}
        </div>
        {/* {departmentList?.length && !props.hideDepartment ? (
          <div className='mt-3'>
            <div className='card-body'>{renderDepartmentDropdown()}</div>
          </div>
        ) : null} */}
      </div>

      {renderPrescriptionList()}

      <Modal backdrop='static' size='lg' open={pdfModal} onClose={closeModalPdf}>
        <Modal.Header>
          <Modal.Title>Prescription View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe src={pdfUrl + '#toolbar=0'} onContextMenu='return false;' width={'100%'} height={window.innerHeight} />
        </Modal.Body>
        <Modal.Footer className='mt-4'>
          <Button onClick={handlePublishAndPrint} appearance='primary'>
            Publish
          </Button>
          <Button onClick={closeModalPdf} appearance='defualt'>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* PDF Modal */}
      <Modal backdrop='static' size='lg' open={showModal} onClose={closeShowModal}>
        <Modal.Header>
          <Modal.Title>Prescription View</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe src={pdfUrl + '#toolbar=0'} onContextMenu='return false;' width={'100%'} height={window.innerHeight} />
        </Modal.Body>
        <Modal.Footer className='mt-4'>
          <Button onClick={handlePublishAndPrint} appearance='primary'>
            Publish
          </Button>
          <Button onClick={closeShowModal} appearance='defualt'>
            Cancel
          </Button>
          {/* <div className='mb-1 ms-2 pointer'> */}
          <Button onClick={printPDF}>
            <CommonToolTip
              placement={'top'}
              item={<span className='material-icons-outlined'>print</span>}
              showValue={'Print Prescription'}
              onClick={handleOpenPDF}
            />
          </Button>
          {/* </div> */}

        </Modal.Footer>
      </Modal>
      {customGoalActivityModal()}
      <Loader show={isLoading} />
      <div className='d-flex justify-content-end'>
        <div className='patientPagination mt-3'>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </>
  );
}

export default RenderPrescriptionTab;
